import { useQueryClient } from '@tanstack/react-query';
import { type SubscriptionInfo } from './subscriptionService';
import { SUBSCRIPTION_QUERY_KEYS } from './keys';

// Typed read of the subscription-info entry owned by useSubscriptionInfo; lives
// here so SUBSCRIPTION_QUERY_KEYS stays internal to api/subscription (ADR-014).
const useSubscriptionInfoData = (family?: string): SubscriptionInfo | null => {
  const queryClient = useQueryClient();
  return (
    queryClient.getQueryData<SubscriptionInfo>(
      SUBSCRIPTION_QUERY_KEYS.subscriptionInfo(family)
    ) ?? null
  );
};

export default useSubscriptionInfoData;
